import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/risques/risqueCardView.css';

const RisqueGridData = React.memo(({ index, style, data }) => {

    const { risques, columns, filteredRisquesCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredRisquesCount);

    const handleRisqueClick = useCallback((risqueId) => navigate(`risque_details/${risqueId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const risqueIndex = startIndex + idx;
                const risque = risques[risqueIndex];

                const imageUrl = entityGridPhotoUrl(risque, 'risk', { size: 'small' });

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={risque ? risque.id : `skeleton-${risqueIndex}`}>
                        <Card className='risques_gridview_card' style={{ position: 'relative', overflow: 'hidden' }}>
                            <CardActionArea onClick={risque ? () => handleRisqueClick(risque?.id) : undefined}>
                                {risque ? (
                                    <>
                                        {/* Blurred Background Image */}
                                        <CardMedia
                                            component="img"
                                            image={imageUrl}
                                            alt=""
                                            style={{
                                                position: 'absolute',
                                                width: '100%',
                                                height: '192px',
                                                top: 0,
                                                left: 0,
                                                zIndex: 0,
                                                objectFit: 'cover',
                                                filter: 'blur(10px)',
                                            }}
                                            loading="lazy"
                                            decoding="async"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = machineDefaultImage;
                                            }}
                                        />

                                        {/* Main Image Over Content */}
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            style={{
                                                position: 'relative',
                                                objectFit: imageUrl !== machineDefaultImage ? 'contain' : 'cover',
                                                zIndex: 1
                                            }}
                                            image={imageUrl}
                                            alt={risque?.name}
                                            loading="lazy"
                                            decoding="async"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = machineDefaultImage;
                                            }}
                                        />

                                        <CardContent className='risques_gridview_card_CardContent' style={{ position: 'relative', zIndex: 2 }}>
                                            <Typography className='risques_gridview_risque_name' component="div">
                                                {risque?.name}
                                            </Typography>
                                            <Typography className='risques_gridview_risque_adress' component="div">
                                                {risque?.description || '--'}
                                            </Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton loading state */}
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='risques_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default RisqueGridData;